package com.trevorwiebe.timesheet.signin.presentation.auth

sealed interface SignInEvents {
    data class OnSignInClick(val email: String, val password: String) : SignInEvents
    data class OnPasswordResetEmailChanged(val email: String) : SignInEvents

    // reset password events
    data class OnSetSendPasswordResetDialog(val show: Boolean) : SignInEvents
    data object OnSendPasswordResetEmail : SignInEvents

}